var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigitalNomad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 432.18 395.04",
    id: "digital-nomad",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 333.94,
    x2: 351.54,
    y1: 307.53,
    y2: 367.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 181.56,
    x2: 201.62,
    y1: 220.61,
    y2: 220.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecc4d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#efd4d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2eac9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 196.89,
    x2: 277.97,
    y1: 295.06,
    y2: 287.18,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 174.86,
    x2: 222.44,
    y1: 328.17,
    y2: 328.17,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 219.11,
    x2: 355.38,
    y1: 320.71,
    y2: 179.93,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 266.97,
    x2: 243.04,
    y1: 252.95,
    y2: 270.03,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 249.35,
    x2: 251.33,
    y1: 331.28,
    y2: 343.57,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 261.64,
    x2: 194.44,
    y1: 189.81,
    y2: 195.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#fff",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 262.68,
    x2: 25.22,
    y1: 138.95,
    y2: 574.43,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 208.67,
    x2: 253.31,
    y1: 193.93,
    y2: 193.93,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 173.38,
    x2: 196.49,
    y1: 201.4,
    y2: 201.4,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 237.46,
    x2: 327.38,
    y1: 354.67,
    y2: 354.67,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 164.38,
    x2: 210.3,
    y1: 372.88,
    y2: 372.88,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 334.82,
    x2: 319.62,
    y1: 350.94,
    y2: 269.85,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 159.49,
    x2: 193.56,
    y1: 434.2,
    y2: 459.82,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 167.55,
    x2: 56.36,
    y1: 97.23,
    y2: 151.76,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 51.54,
    x2: 55.76,
    y1: 292.31,
    y2: 289.21,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 80.05,
    x2: 83.62,
    y1: 269.63,
    y2: 266.91,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 80.63,
    x2: 110.47,
    y1: 287.66,
    y2: 322.29,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 207.58,
    x2: 239.11,
    y1: 92.92,
    y2: 133.19,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 253.61,
    x2: 235.87,
    y1: 173.91,
    y2: 173.07,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 227,
    x2: 317.85,
    y1: 143.07,
    y2: 239.18,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 281.56,
    x2: 198.29,
    y1: 280.24,
    y2: 339.68,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 205.46,
    x2: 295,
    y1: 311.44,
    y2: 348.98,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 157.91,
    x2: 318.25,
    y1: 344.8,
    y2: 412.03,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 238.7,
    x2: 348.51,
    y1: 351.34,
    y2: 252.38,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 511.35,
    x2: 239.36,
    y1: 134.39,
    y2: 189.02,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 432.29,
    x2: 299.17,
    y1: 99.61,
    y2: 126.35,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 469.02,
    x2: 185.77,
    y1: 103.99,
    y2: 311.22,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 399.27,
    x2: 165.81,
    y1: 91.99,
    y2: 262.8,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: 365.75,
    x2: 297.3,
    y1: 129.24,
    y2: 142.99,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 84.38,
    x2: 73.49,
    y1: 276.94,
    y2: 325.36,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: 161.85,
    x2: 167.67,
    y1: 432.12,
    y2: 460.09,
    xlinkHref: "#a"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M413.64 256c-9.46 10.5-21.41 18.61-30.31 29.6-11.84 14.62-17.77 33.67-26.79 50.06a94.86 94.86 0 0 1-7.66 11.88 59.81 59.81 0 0 1-10.49 10.73c-17.1 13.43-40.71 14.85-62.33 12.58-21.06-2.2-42.07-7.35-63.14-5.74l-1.7.14c-9.43.89-18.81 3.17-28.16 5.15-12.3 2.6-24.55 4.69-36.79 2.41A53.69 53.69 0 0 1 110 347c-8.38-14.73-9.28-32.59-16.28-48-4.76-10.49-12.2-19.55-17.44-29.81A80.87 80.87 0 0 1 76.6 196c6.84-13.05 17.12-23.91 27.27-34.58l30.67-32.25c10-10.5 20.3-21.24 33.42-27.39a58.72 58.72 0 0 1 31.72-4.9c8.8 1 15.56 6.11 23.15 8.92a30.51 30.51 0 0 0 4.75 1.39c9.23 1.9 19.21-.7 29 .69.77.1 1.53.24 2.29.4 10.71 2.26 21 6.62 30.74 11.48 18.67 9.27 36.78 20.69 57.28 24.52 17.34 3.23 35.82.88 52.19 7.43 19.12 7.63 32.28 27.16 34.39 47.63s-6.04 41.35-19.83 56.66Z",
    opacity: 0.25,
    transform: "translate(-40.63 -57.59)",
    style: {
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "m293.19 255.72-4 1.57s2.43.21 6.23 7.59 13.75 30.44 13.35 33.38c0 0 3.68-.16 4.39-1.85.02 0-9.98-31.68-19.97-40.69Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "m333.82 313.31-4 1.57s2.43.21 6.23 7.59 13.75 30.44 13.35 33.38c0 0 3.68-.16 4.39-1.85.02 0-9.98-31.68-19.97-40.69Z",
    transform: "translate(-40.63 -57.59)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M201.62 220.61s-13.2 20.6-16.86 19.13-3.18-22.07-3.18-22.07l15.87-16.27Z",
    transform: "translate(-40.63 -57.59)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#484756",
    d: "M161.37 166.1s-5.57 16.58-12.05 18.9-11.65 16.8-9.2 20.82l4 6.56 5.35-4.51s-5.5-7.14-2.23-12.14c4.25-6.49 2.1-.48 7.79-7.75s7.17-12.44 7.17-12.44Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M135.67 253.6c-1.37 3.77-2.52 8.22-.34 11.59 1.44 2.23 4 3.42 6.45 4.44a177.75 177.75 0 0 0 32.59 10c2.55.53 5.57.88 7.44-.93a8.34 8.34 0 0 0 1.82-3.44l8.09-23.75c5.47-16 11-32.19 19.36-46.93 1.46-2.58 3.07-5.46 2.37-8.35-.63-2.64-3.13-4.52-5.76-5.21-7.4-2-16.38.72-24.08.2-4.26-.29-9-1.31-12.86 1-5.32 3.16-8.52 11-11.66 16-4.26 6.84-8.42 13.74-12.24 20.83a182.7 182.7 0 0 0-11.18 24.55Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M251.71 262.21c-8.37 14.74-13.89 30.89-19.36 46.93q-3.06 9-6.14 18l-2 5.73a8.34 8.34 0 0 1-1.82 3.44 4.55 4.55 0 0 1-1.89 1.08 11.74 11.74 0 0 1-5.55-.15 177.75 177.75 0 0 1-32.59-10c-2.45-1-5-2.21-6.45-4.44a7.24 7.24 0 0 1-1.1-3c-.43-2.79.45-5.88 1.44-8.62a182.7 182.7 0 0 1 11.18-24.5c3.82-7.09 8-14 12.24-20.83 3.14-5.05 6.34-12.85 11.66-16 3.89-2.31 8.6-1.29 12.86-1 7.7.52 16.68-2.16 24.08-.2 2.63.69 5.13 2.57 5.76 5.21.75 2.89-.86 5.77-2.32 8.35Z",
    transform: "translate(-40.63 -57.59)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M222.44 336.33c-1.87 1.81-4.89 1.46-7.44.93-3.05-.62-6.09-1.33-9.1-2.12a178.17 178.17 0 0 1-23.49-7.92c-.81-.34-1.64-.69-2.42-1.11a10 10 0 0 1-4-3.33 7.24 7.24 0 0 1-1.1-3l1.38-.68a44 44 0 0 1 7.69-.46 41.36 41.36 0 0 1 18.15 4.26c1.07.56 2.11 1.13 3.12 1.7a123.67 123.67 0 0 1 17.21 11.73Z",
    transform: "translate(-40.63 -57.59)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M187.37 277.48c.79 2.12 1.8 4.39 3.82 5.43 1.62.85 3.56.71 5.39.52a252.35 252.35 0 0 0 30.41-4.9 3.12 3.12 0 0 0 1.48-.63 3.07 3.07 0 0 0 .63-2.21c.29-14.21-.52-28.58 2.42-42.49 1.17-5.51 2.92-10.91 3.5-16.51a40.65 40.65 0 0 0-8.95-29.7 3.42 3.42 0 0 0-1.57-1.25 3.8 3.8 0 0 0-2.51.55c-8.07 3.75-17.13 3.73-25.84 3.64-6.24-.07-14.13-1.72-14.69 6.27-1.19 16.89-2.07 34.58-.54 51.49a115.58 115.58 0 0 0 6.45 29.79Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M275.68 274.28c-.58 5.6-2.33 11-3.5 16.51-2.94 13.91-2.13 28.28-2.42 42.49a3.65 3.65 0 0 1-.39 1.9 1.18 1.18 0 0 1-.24.31 3.12 3.12 0 0 1-1.48.63 252.35 252.35 0 0 1-30.41 4.9c-1.83.19-3.77.33-5.39-.52-2-1-3-3.31-3.82-5.43a115.58 115.58 0 0 1-6.45-29.79c-1.53-16.91-.65-34.6.54-51.49.56-8 8.45-6.34 14.69-6.27 8.71.09 17.77.11 25.84-3.64a3.8 3.8 0 0 1 2.51-.55 3.42 3.42 0 0 1 1.57 1.25c.43.52.84 1 1.23 1.58a40.69 40.69 0 0 1 7.72 28.12Z",
    transform: "translate(-40.63 -57.59)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M252.34 248.29s2.08 18.56 14.75 19.69L265 245.84Z",
    transform: "translate(-40.63 -57.59)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M269.76 333.28c0 .08 0 1.88-3.73 2.57-.39.07-.82.13-1.29.17-5.07.47-26.79 4.48-26.79 4.48s-7.09 1.66-7.65-2.82c0 0 2.88-1.06 7.19-2.29 7.38-2.11 19-4.73 27.57-3.4a20.1 20.1 0 0 1 4.7 1.29Z",
    transform: "translate(-40.63 -57.59)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#484756",
    d: "M203.83 84.33c-.11.35-.72.15-.75-.22s.29-.66.57-.89a21.44 21.44 0 0 1 15-4.53 5.36 5.36 0 0 1 2.89.9 6.07 6.07 0 0 1 1.6 2.4 256.72 256.72 0 0 1 16.89 52c.71 3.36 1.73 7.23 4.87 8.6 3.35 1.47 7.37-1 8.85-4.35s1.08-7.18.53-10.79a126.89 126.89 0 0 0-8.23-30.08c-2.98-6.96-6.68-13.58-9.68-20.46s-6.07-14.62-12.52-18.68-14.44-3.4-21.79-2c-6.36 1.21-13.52 3.71-15.72 9.79-1.78 4.92.59 10.61 4.53 14s9.15 5 14.27 6.05a11.72 11.72 0 0 0 4.85.26"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#25233a",
    d: "M216.46 66.24c3.1.29 6.36.91 8.66 3a15.83 15.83 0 0 1 3.25 4.89c9.41 19.11 15.75 39.56 22.06 59.91 1.07 3.47 2.13 7.31.69 10.64-1.34 3.07-4.48 4.91-7.5 6.36a89.37 89.37 0 0 1-17 6.15 3.15 3.15 0 0 1-4.18-1.44c-4.85-6.68-8.06-14.38-11.21-22L190.74 84.3c-1.13-2.73-4.29-7.46-4.35-10.44-.07-3.59 2.75-4.14 5.92-5.13a61.46 61.46 0 0 1 24.15-2.49Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M142.66 100.35a215.08 215.08 0 0 0-8.86 31.6 3.85 3.85 0 0 0 2.35 5.05l9.43 5.93c2 1.26 4.78 2.48 6.54.89 1.15-1 1.22-2.79 1.19-4.34q-.24-17.67-1.4-35.31c-.19-2.84 1.31-13.16-2.29-14.13s-6 7.69-6.96 10.31Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M172.6 79.69c-6.51.56-13.41 1.48-18.45 5.63a22.79 22.79 0 0 0-4.11 4.55 35.21 35.21 0 0 0-6.36 21.74c.28 5.93 2.06 11.68 3.83 17.35 3.62 11.59 7.24 23.19 11.41 34.6 3 8.35 3.09 21.32 9.12 27.86 1.9 2.05 7.5-.6 10.08.5 3.33 1.42 7.06 1.46 10.68 1.35a144.88 144.88 0 0 0 28.2-3.69c2.28-.54 8-.54 9.1-2.59.7-1.27 1.76-1.76 1.76-3.21.06-18.8-4.9-39.4-6.52-58.14-1-11.19-2.33-22.71-7.84-32.5s-16.13-17.51-27.34-16.21c-3.98.48-9.58 2.41-13.56 2.76Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M268.49 241.37c0 1.45-1.06 1.94-1.76 3.21a3.25 3.25 0 0 1-1.75 1.26 33.66 33.66 0 0 1-6.35 1.15c-.36.05-.69.11-1 .17a144.88 144.88 0 0 1-28.2 3.69c-3.62.11-18.86.2-20.76-1.85-6-6.54-6.07-19.51-9.12-27.86-4.17-11.41-7.79-23-11.41-34.6-1.77-5.67-3.55-11.42-3.83-17.35a35.21 35.21 0 0 1 6.36-21.74 22.79 22.79 0 0 1 4.11-4.55 21.62 21.62 0 0 1 8-4 56.27 56.27 0 0 1 10.42-1.65c4-.35 9.58-2.3 13.56-2.76a21.31 21.31 0 0 1 4.37-.06 24.76 24.76 0 0 1 8.7 2.5 31 31 0 0 1 7.67 5.36 35.4 35.4 0 0 1 6.59 8.41c5.51 9.79 6.88 21.31 7.84 32.5 1.66 18.8 6.62 39.37 6.56 58.17Z",
    transform: "translate(-40.63 -57.59)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M268.49 241.37c0 1.45-1.06 1.94-1.76 3.21a3.25 3.25 0 0 1-1.75 1.26l-6.35 1.16-1 .17-4.32-67.17-23.39-17s-6.76-9.65-10.14-9.65-13.73-6.61-13.73-6.61c-2.9.28-11 26.32-11 26.32l2.76-28.81 5-5.35 5.86-4.55 18.12.14 4.37-.06 5.75-.08 3 2.58 4.41 3.85 3.26 1.51a35.4 35.4 0 0 1 6.59 8.41c5.51 9.79 6.88 21.31 7.84 32.5 1.58 18.8 6.54 39.37 6.48 58.17Z",
    transform: "translate(-40.63 -57.59)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#484756",
    d: "M222.25 161.95s11.53-6 15.84-14.75l3.19 2.56s-10.12 16.34-18.57 16.34-.46-4.15-.46-4.15Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#25233a",
    d: "M184.29 82.84c-8.16 13.25-12.4 29.83-8.65 44.93 2.76 11.07 10.43 20.24 18.65 28.15 3.66 3.52 7.54 6.92 12.09 9.17s9.91 3.24 14.77 1.78c1.63-.49 3.48-2 2.78-3.52a3.38 3.38 0 0 0-1.68-1.4c-8.15-4.17-16.65-8.57-22-16-4.06-5.64-6-12.53-7.26-19.35-2.22-11.55-2.86-24.09 2.6-34.51 2.73-5.22 6.94-9.81 8.13-15.58.07-.36-11.09-3.32-12.39-3-3.51 1.01-5.27 6.44-7.04 9.33ZM142.74 100.76c-4 19.62 3.61 60.92 17 65.34.31-2.13-5.07-22.2-5.53-39.05-.89-32.91 11.08-43.58 11.23-46.46.07-1.43-4.91-3.71-11.22.51-6.75 4.51-9.85 11.93-11.48 19.66Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M227.54 170.36a323.79 323.79 0 0 0-1.2 41.2c7.66-9.92 9.06-23.16 10.17-35.64a28.47 28.47 0 0 1 7.89 2.92 9.65 9.65 0 0 1 4.78 6.63c.21 1.55 4.41 4.26 4.11 5.78-1.89 9.49-15.88 31.91-18.86 34.78-5.07 4.85-10.07 6.78-14.81 1.61s-6.22-12.5-6.92-19.47a126.15 126.15 0 0 1-.17-23.48c0 .49-3.21-3.5-3.41-4.13-.75-2.33-.38-5-.14-7.4.42-4 .82-9.1 3.12-12.58 2.13-3.23 5.4-4.13 9.08-2.9 5.82 1.95 6.88 7.2 6.36 12.68Z",
    transform: "translate(-40.63 -57.59)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M174.22 204.82c1.54-11.38 4.06-17.27 5.6-28.64.47-3.49 1-7.16 3.15-10s6.44-4.29 9.28-2.2c2.1 1.53 2.71 4.36 3.16 6.92a43.94 43.94 0 0 1 1 11.18c-.3 3.74-1.68 7.54-4.5 10a13.52 13.52 0 0 0-2.82 2.67 8.08 8.08 0 0 0-.93 3.7c-.9 12 1.06 24.07-.21 36-.23 2.19-1 4.85-3.19 5.23a4.71 4.71 0 0 1-3.65-1.48c-4.5-3.92-6.78-9.9-7.36-15.84a66.08 66.08 0 0 1 .47-17.6",
    transform: "translate(-40.63 -57.59)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M327.38 338.61a2.82 2.82 0 0 1-1 1.63c-18.07 17.46-37.67 34.34-61.33 42.81-2.83 1-6 1.91-8.81.91-3.43-1.2-15.64-29.53-18.25-43.46-.15-.79-.27-1.53-.35-2.21a15.61 15.61 0 0 1-.11-2.89c7.38-2.11 19-4.73 27.57-3.4l.25.89c0 .11.05.21.07.32.2.89.42 1.77.65 2.65.54 2.11 1.15 4.2 1.81 6.27q.94 3 2.09 5.88a3.41 3.41 0 0 0 1.26 1.84c.92.54 2.08.14 3.06-.28a236.77 236.77 0 0 0 43-23.82 3 3 0 0 1 2.11-.78c.87.14 1.42 1 1.85 1.79q2.83 5.17 5.68 10.34a2.93 2.93 0 0 1 .45 1.51Z",
    transform: "translate(-40.63 -57.59)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M210.3 327.58c-.31 1.54-3.77 6.14-4.4 7.56-1.94 4.38-5.07 8.32-7.3 12.62a67.19 67.19 0 0 0-5 14.55q-4.4 17.26-7.74 34.75-2.87 14.94-5 30a55.34 55.34 0 0 1-13.06-4.39 6.74 6.74 0 0 1-2.52-1.77c-.95-1.23-1-2.92-1-4.48a361.47 361.47 0 0 1 3.36-45.78c1.84-12.64 4.36-25.36 9.36-37.15.66-1.55 1.71-4.41 3-7.38a53.81 53.81 0 0 1 2.87-5.79c.35-.59.7-1.13 1.06-1.63a41.36 41.36 0 0 1 18.15 4.26c1.07.56 2.11 1.13 3.12 1.7.8.5 5.1 2.93 5.1 2.93Z",
    transform: "translate(-40.63 -57.59)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M289.21 257.29a1.78 1.78 0 0 1 1.27-.3 1.85 1.85 0 0 1 1 .93 175.26 175.26 0 0 1 16.88 37c.48 1.51.91 3.29 0 4.56a4.11 4.11 0 0 1-2.27 1.35c-5.08 1.36-10.19-1.68-14.57-4.58l-12.18-8.06c1.17.77 1.57-8.59 1.42-9.33-.75-3.69-3.23-6.2-4.63-9.54-2.97-6.91 8.12-9.49 13.08-12.03ZM127.79 363.65c4 3.18 9.79 1.69 14.61.06a111.09 111.09 0 0 1 4.86 18.75 6 6 0 0 1-.16 3.64 5.88 5.88 0 0 1-3 2.43c-12.06 5.73-25.87 6.17-39.22 6.5a6 6 0 0 1-2.42-.27c-2.65-1.07-2.45-4.91-1.42-7.57 2.93-7.58 8.8-11.14 13.51-17.22 1.64-2.12 2.7-4.53 4.57-6.51 3.53-3.72 5.09-2.67 8.67.19Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M329.84 314.88a1.78 1.78 0 0 1 1.27-.3 1.85 1.85 0 0 1 1 .93 175.26 175.26 0 0 1 16.88 37c.48 1.51.91 3.29 0 4.56a4.11 4.11 0 0 1-2.27 1.35c-5.08 1.36-10.19-1.68-14.57-4.58l-12.18-8.06c1.17.77 1.57-8.59 1.42-9.33-.75-3.69-3.23-6.2-4.63-9.54-2.97-6.91 8.12-9.49 13.08-12.03Z",
    transform: "translate(-40.63 -57.59)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M187.73 443.69a5.88 5.88 0 0 1-3 2.43c-12.06 5.73-25.87 6.17-39.22 6.5a6 6 0 0 1-2.42-.27c-1.9-.77-2.33-3-2-5.11a10.45 10.45 0 0 1 .63-2.46c2.93-7.58 8.8-11.14 13.51-17.22 1.64-2.12 2.7-4.53 4.57-6.51 3.52-3.72 5.08-2.67 8.66.19 4 3.18 9.79 1.69 14.61.06a110.36 110.36 0 0 1 4.63 17.7c.07.35.13.7.19 1.05a6 6 0 0 1-.16 3.64Z",
    transform: "translate(-40.63 -57.59)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M121.82 72.01a322.65 322.65 0 0 1-43.78 32.93l-.8.48a4.5 4.5 0 0 1-3.88.66c-1.24-.52-1.88-1.85-2.44-3.07-9.46-20.58-28.34-35.28-35.94-56.83 14.55-11.01 33.19-18.77 49.17-27.77 1.35-.76 2.86-1.54 4.36-1.35a2.79 2.79 0 0 1 .4.07c1.6.4 2.66 1.86 3.57 3.22a407.17 407.17 0 0 1 29.34 51.66Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M162.45 129.6a322.65 322.65 0 0 1-43.78 32.93l-.8.48a2.91 2.91 0 0 1-.5-.16c-1.24-.52-1.88-1.86-2.44-3.08C105.47 139.2 86.59 124.5 79 103c14.55-11 33.19-18.83 49.17-27.77.32-.18.65-.36 1-.52a2.79 2.79 0 0 1 .4.07c1.6.4 2.66 1.86 3.57 3.22a407.17 407.17 0 0 1 29.31 51.6Z",
    transform: "translate(-40.63 -57.59)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M.1 219.54a.73.73 0 0 1 1.15-.87c7 7 22.24 27.87 22.57 28.52a1.76 1.76 0 0 1-.44 2.27c-3.11 1.85-11.63-11.61-13.12-13.69A148.92 148.92 0 0 1 .1 219.54ZM28.15 198.49c-.45-.83.63-1.4 4.08 2.09 23.32 23.61 20.85 24.83 18.24 25.2-1.63.25-4-3.67-4.82-4.62-3.88-4.75-15.9-19.7-17.5-22.67Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M40.73 277.13a.73.73 0 0 1 1.15-.87c7 7 22.24 27.87 22.57 28.52a1.76 1.76 0 0 1-.44 2.27c-3.11 1.85-11.63-11.61-13.12-13.69a148.92 148.92 0 0 1-10.16-16.23Z",
    transform: "translate(-40.63 -57.59)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M68.78 256.08c-.45-.83.63-1.4 4.08 2.09 23.32 23.61 20.85 24.83 18.24 25.2-1.63.25-4-3.67-4.82-4.62-3.88-4.75-15.9-19.7-17.5-22.67Z",
    transform: "translate(-40.63 -57.59)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M74.37 235.23c-2.33 3.66-5.95 6.27-9.45 8.84a151.3 151.3 0 0 0-13.55 10.94 43.37 43.37 0 0 1-6.77 5.65 17.66 17.66 0 0 1-14 1.78c-3.68-1.1-8.66-4.16-10.1-8a4.69 4.69 0 0 1-.17-.58c-.86-4 4.83-7.13 7.74-9.17a112.16 112.16 0 0 0 19.44-17.23 12.92 12.92 0 0 1 3.86-3.32 12.24 12.24 0 0 1 4.07-.91l15.78-1.68a4.45 4.45 0 0 1 2.46.2 3 3 0 0 1 1 .88 4 4 0 0 1 .24.33c2.51 3.57 1.77 8.61-.55 12.27Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M115 292.82c-2.33 3.66-5.95 6.27-9.45 8.84A151.3 151.3 0 0 0 92 312.6a43.37 43.37 0 0 1-6.77 5.65 17.66 17.66 0 0 1-14 1.78c-3.68-1.1-8.66-4.16-10.1-8a4.69 4.69 0 0 1-.17-.58c-.86-4 4.83-7.13 7.74-9.17a112.16 112.16 0 0 0 19.44-17.23 12.92 12.92 0 0 1 3.86-3.32 12.24 12.24 0 0 1 4.07-.91l15.78-1.68a4.45 4.45 0 0 1 2.46.2 3 3 0 0 1 1 .88 4 4 0 0 1 .24.33c2.51 3.57 1.77 8.61-.55 12.27Z",
    transform: "translate(-40.63 -57.59)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M74.72 222.63c-.41.34-.76.63-1 .88-5.5 5.27-11.11 10.44-16.49 15.83a64.62 64.62 0 0 1-8.56 7.3c-8.22 5.49-18.3 6.77-28.3 7.25-.86-4 4.83-7.13 7.74-9.17a112.16 112.16 0 0 0 19.44-17.23 12.92 12.92 0 0 1 3.82-3.35 12.24 12.24 0 0 1 4.07-.91l15.78-1.68a4.45 4.45 0 0 1 2.46.2 3 3 0 0 1 1.04.88Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M235.18 123.73c-1.28 1.15-3.66 2.52-5.63 4a10.49 10.49 0 0 0-2.87 2.86c-1.13 2.07-.91 5.61-1.19 6.61-2.27 8-6.93 10.7-10.48 10.36a5.38 5.38 0 0 1-1.22-.24c-5.78-1.86-7.95-8.74-9.3-14.66s-2.71-12-4.07-18c-1.25-5.51-2.51-11.06-2.64-16.71s.93-11.46 4-16.2a16.51 16.51 0 0 1 4.88-5c3.22-2.05 7.16-2.62 11-2.87 6.8-.44 15.14.76 19 7.22 3.11 5.18 2.88 14.64 3.1 20.43s-.18 18.21-4.58 22.2Z",
    transform: "translate(-40.63 -57.59)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#25233a",
    d: "M196.05 11.48c-1.2 4.82-5.61 8.37-10.39 9.74-3.49 1-7.19 1-10.75 1.75s-7.21 2.44-8.88 5.66c-1.26 2.43-1.2 5.3-1.11 8l.51 14.81-2.9-3.74a1.91 1.91 0 0 0-1-.8c-.95-.25-1.63.92-1.78 1.89a8.69 8.69 0 0 0 3.44 8.16 4.88 4.88 0 0 1 1.73 1.58 3.82 3.82 0 0 1 0 2.52l-1.43 6.4c-4-1.82-6.52-5.91-8.2-10-2.69-6.48-4-13.46-4.78-20.43-.42-3.65-.71-7.4.18-11s3.16-7 6.56-8.34c-1.81-4.08.67-9.06 4.42-11.47s8.41-2.88 12.87-3.12c3-.15 6.49 0 9.35-.95 2.27-.77 3.53-2.54 6-2.18 4.88.79 7.19 7.45 6.16 11.52Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M192.42 138.48c5.48 1.49 15.48 5.47 20.24 8.57 4.36 2.84 4.49-35 4.47-42.35 0-3.93-.22-8-1.93-11.51-3-6.15-14.4-12.7-17.68-4-3.73 9.87-6.42 48.93-5.1 49.29Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "M233.05 196.07c5.48 1.49 15.48 5.47 20.24 8.57 4.36 2.84 4.49-35 4.47-42.35 0-3.93-.22-8-1.93-11.51-3-6.15-14.4-12.7-17.68-4-3.73 9.87-6.42 48.93-5.1 49.29Z",
    transform: "translate(-40.63 -57.59)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#484756",
    d: "M221.15 166.87s9.42 8.42-.94 14.7-4.17 22.2-4.17 22.2h6.9s-4.51-9.57-.28-15.91 6.61-6.47 6.61-12.95-5.34-11.56-5.34-11.56Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "M229.55 127.69a10.49 10.49 0 0 0-2.87 2.86c-1.13 2.07-.91 5.61-1.19 6.61-2.27 8-6.93 10.7-10.48 10.36l-1.22-.24s.64-20.17 6.65-18.58 9.1-1.12 9.1-1.12Z",
    transform: "translate(-40.63 -57.59)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    d: "M275.68 274.28c-.58 5.6-2.33 11-3.5 16.51-2.94 13.91-2.13 28.28-2.42 42.49a3.65 3.65 0 0 1-.39 1.9l-7-3.47s-1.48-26.56 2.34-36.44 2.38-27.27 2.38-27.27L265 245.84l3 .32a40.69 40.69 0 0 1 7.68 28.12Z",
    transform: "translate(-40.63 -57.59)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    d: "m226.21 327.16-2 5.73a8.34 8.34 0 0 1-1.82 3.44 4.55 4.55 0 0 1-1.89 1.08l-13-11.41 13.63-27.61Z",
    transform: "translate(-40.63 -57.59)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#y)",
    d: "M210.3 327.58c-.31 1.54-3.77 6.14-4.4 7.56-1.94 4.38-5.07 8.32-7.3 12.62a67.19 67.19 0 0 0-5 14.55q-4.4 17.26-7.74 34.75c2-16.82 4.44-37.11 5.17-42.39 1.32-9.42 9.67-18.46 9.67-18.46s2.91-7.88-2.08-12.11-15.79-3.78-15.79-3.78c.35-.59.7-1.13 1.06-1.63a41.36 41.36 0 0 1 18.15 4.26c1.07.56 2.11 1.13 3.12 1.7.84.5 5.14 2.93 5.14 2.93Z",
    transform: "translate(-40.63 -57.59)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#z)",
    d: "m267.85 342.12-8.13-6.94c-5-.84-22.11 3.11-22.11 3.11a15.61 15.61 0 0 1-.11-2.89c7.38-2.11 19-4.73 27.57-3.4l.25.89Z",
    transform: "translate(-40.63 -57.59)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M409.02 135.85c.17.22.05.17 0 0Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M409.02 135.85c.17.22.05.17 0 0Zm23.12-53.23c.59-8.13-4.52-14.67-11.22-19.32-22-15.28-63.07-36.95-65.51-37.8-2-.71-3.85 1-5.43 4.18-6.28 12.66-9 49.1-7.94 56.48a10.68 10.68 0 0 0-2.67 2.05s-34.24 20.06-43.94 27.66l-.44.35c-2.33 1.88-3.13 5.21 1.78 8.79 20.07 14.64 47.4 36.31 67.47 51a6.8 6.8 0 0 0 3.45 1.62c1.59.1 3-.91 4.28-1.88l48.44-36.72c.82-.62 1.72-1.44 1.59-2.46-.07-.81 8.63-33.11 10.14-53.95Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#A)",
    d: "M467.33 138.88c.55-7.68-4.27-13.86-10.6-18.25-20.73-14.43-59.58-34.9-61.88-35.71-1.55-.54-3 .39-4.24 2.35-6.28 12.66-9 49.1-7.94 56.48a10.68 10.68 0 0 0-2.67 2.05s-34.24 20.06-43.94 27.66c-.19 1.59.68 3.49 3.39 5.46 19 13.83 44.78 34.3 63.73 48.13a6.47 6.47 0 0 0 3.26 1.53c1.51.09 2.85-.86 4-1.78l45.75-34.68c.78-.59 1.63-1.36 1.51-2.33a2.61 2.61 0 0 0-1.3-1.63 3.74 3.74 0 0 0 .52-.28c1.93-1.25 8.98-29.31 10.41-49Zm-21.84 50.28c.16.21 0 .16 0 0Z",
    transform: "translate(-40.63 -57.59)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M409.02 135.85c.17.22.05.17 0 0Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    d: "m342.04 86.16 75.11 46.04-1.51 2.33-75.49-47.03 1.89-1.34z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "m353.91 33.57 66.26 40.36s-2.64 36-7.7 51.43l-67-41.86Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#C)",
    d: "m394.54 91.16 66.26 40.36s-2.64 36-7.7 51.43l-67-41.86Z",
    transform: "translate(-40.63 -57.59)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#D)",
    d: "m319.37 106.78 22.24-13.52 63.25 38.31-24.88 17.24-60.61-42.03z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#E)",
    d: "m332.88 121.98 23.47 15.96-14.46 9.95-21.77-16.18 12.76-9.73z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#F)",
    d: "M63.14 309.18s15.37-.91 21-4.1a53.29 53.29 0 0 0 9.15-6.48l3.92-16.35a10.29 10.29 0 0 0-4.49.37c-1.62.75-8.43 8.26-15.26 14.27-5.67 4.98-14.22 9.19-14.32 12.29Z",
    transform: "translate(-40.63 -57.59)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#68e1fd",
    d: "M147.1 386.1a5.88 5.88 0 0 1-3 2.43c-12.06 5.73-25.87 6.17-39.22 6.5a6 6 0 0 1-2.42-.27c-1.9-.77-2.33-3-2-5.11 1.57 0 25.72.25 34.25-3.38 8.82-3.75 12-5.82 12-5.82l.36 1c.07.35.13.7.19 1.05a6 6 0 0 1-.16 3.6Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#G)",
    d: "M187.73 443.69a5.88 5.88 0 0 1-3 2.43c-12.06 5.73-25.87 6.17-39.22 6.5a6 6 0 0 1-2.42-.27c-1.9-.77-2.33-3-2-5.11 1.57 0 25.72.25 34.25-3.38 8.82-3.75 12-5.82 12-5.82l.36 1c.07.35.13.7.19 1.05a6 6 0 0 1-.16 3.6Z",
    transform: "translate(-40.63 -57.59)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalNomad);
export default __webpack_public_path__ + "static/media/digital-nomad.4b7e8cd2822d1e91303944d7a8b64aeb.svg";
export { ForwardRef as ReactComponent };